export const FETCH_QUESTIONS = 'TASTE_PROFILE_ONBOARDING/FETCH_QUESTIONS'
export const FETCH_QUESTIONS_SUCCESS = 'TASTE_PROFILE_ONBOARDING/FETCH_QUESTIONS_SUCCESS'
export const FETCH_QUESTIONS_FAILURE = 'TASTE_PROFILE_ONBOARDING/FETCH_QUESTIONS_FAILURE'
export const TOGGLE_FILTER = 'TASTE_PROFILE_ONBOARDING/TOGGLE_FILTER'
export const TOGGLE_FILTER_EXPANSION = 'TASTE_PROFILE_ONBOARDING/TOGGLE_FILTER_EXPANSION'
export const SET_ORDER_BY = 'TASTE_PROFILE_ONBOARDING/SET_ORDER_BY'
export const UPDATE_PRICE_FILTER = 'TASTE_PROFILE_ONBOARDING/UPDATE_PRICE_FILTER'
export const CLEAR_ALL_FILTERS = 'TASTE_PROFILE_ONBOARDING/CLEAR_ALL_FILTERS'

export const fetchQuestions = () => ({
  type: FETCH_QUESTIONS
})

export const fetchQuestionsSuccess = (questions) => ({
  type: FETCH_QUESTIONS_SUCCESS,
  questions
})

export const fetchQuestionsFailure = (error) => ({
  type: FETCH_QUESTIONS_FAILURE,
  error
})

export const toggleFilter = (props) => ({
  type: TOGGLE_FILTER,
  payload: { ...props }
})

export const toggleFilterExpansion = (filter) => ({
  type: TOGGLE_FILTER_EXPANSION,
  payload: { ...filter }
})

export const setOrderBy = (name, value, router) => ({
  type: SET_ORDER_BY,
  payload: {
    name,
    value,
    router
  }
})

export const updatePriceFilter = (payload) => ({
  type: UPDATE_PRICE_FILTER,
  payload
})

export const clearAllFilters = () => ({
  type: CLEAR_ALL_FILTERS
})
